<template>
  <pt-insure-info-detail :insureInfoDetail="insureInfoDetail" class="pt-insure-info-detail__withData"></pt-insure-info-detail>
</template>

<script>
import PtInsureInfoDetail from './index'
export default {
  name: 'pt-insure-info-detail__withData',
  components: {
    'pt-insure-info-detail': PtInsureInfoDetail
  },
  data () {
    return {
      detailLoading: false,
      insureInfoDetail: {}
    }
  },
  methods: {
    getInsureMaterialsDetail () {
      this.detailLoading = true
      this.$store.dispatch('getInsureMaterialsDetail', this.$route.params.id).then(res => {
        this.detailLoading = false
        this.insureInfoDetail = res
        // 是否隐藏第二个问题
        if (this.insureInfoDetail.healthQas && this.insureInfoDetail.healthQas[0] && this.insureInfoDetail.healthQas[0].answer.some(item => item === 'A 否')) {
          this.insureInfoDetail.healthQas = [this.insureInfoDetail.healthQas[0]]
        }
      }).catch(err => {
        this.detailLoading = false
        this.$message(err || '获取详情失败')
      })
    }
  },
  created () {
    this.getInsureMaterialsDetail()
  }
}
</script>
